export default "__VITE_ASSET__6268e726__"